import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.featuredArticlesSlider = ($this) => {
    const sliderEl = $this.querySelector('.featured-articles-swiper');
    let slider;

    if (sliderEl) {
        slider = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centerInsufficientSlides: true,
        });
    }
};
